<template>
  <div class="integration-card claude-card" @click="$emit('open')">
    <div class="integration-card__content">
      <div class="integration-card__icon">
        <div class="integration-card__icon-inner">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path
              fill="#d97757"
              d="M12 1.5l1.8 6.4L20.5 10l-6.7 2.1L12 18.5l-1.8-6.4L3.5 10l6.7-2.1L12 1.5z"
            />
          </svg>
        </div>
      </div>
      <div class="integration-card__info">
        <h3 class="integration-card__title">Claude</h3>
        <p class="integration-card__description">
          Vraag Claude naar offertes, klanten, planning en facturen.
        </p>
      </div>
      <div class="integration-card__actions">
        <Btn variant="tertiary" size="sm" @click.stop="$emit('open')">Handleiding</Btn>
      </div>
    </div>
  </div>
</template>

<script>
  import Btn from '@/components/partials/Btn.vue';

  export default {
    name: 'ClaudeIntegrationCard',

    components: { Btn },

    emits: ['open'],
  };
</script>

<style scoped lang="scss">
  .integration-card {
    background: white;
    border: 1px solid var(--slate-200);
    border-radius: 8px;
    padding: 16px;
    cursor: pointer;
    transition: all 0.2s ease;

    @include hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    &__content {
      display: flex;
      align-items: flex-start;
      gap: 16px;
    }

    &__icon {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      border: 1px solid var(--slate-200);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: var(--white);
    }

    &__icon-inner {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__info {
      flex: 1;
      min-width: 0;
    }

    &__title {
      font-size: 1rem;
      font-weight: 600;
      margin: 0 0 4px 0;
      color: var(--slate-900);
    }

    &__description {
      margin: 0;
      font-size: 0.8125rem;
      color: var(--slate-500);
      @include ellipsis(2);
    }

    &__actions {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      flex-shrink: 0;
    }
  }
</style>
